import { render, staticRenderFns } from "./TechnicianRequests.vue?vue&type=template&id=1513afbc&scoped=true&"
import script from "./TechnicianRequests.vue?vue&type=script&lang=js&"
export * from "./TechnicianRequests.vue?vue&type=script&lang=js&"
import style0 from "./TechnicianRequests.vue?vue&type=style&index=0&id=1513afbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513afbc",
  null
  
)

export default component.exports